/**
 * Variations of a PRINT product (FLYERALARM...): the valid combinations of
 * the configurator steps, each with its production template.
 *
 * Such a product can have thousands of them, so they are shown as a paged
 * table filtered by step value instead of one view per variation. The options
 * of a variation only carry code / categoryCode / pimId (the importer slims
 * them), their names are read from the option categories.
 */
define('editPimPrintVariationsView',[
  'module',
  'marionette',
  'underscore',
  'settings',
  'template!editPimPrintVariationsTpl'
], function (
  module,
  Marionette,
  _,
  Settings,
  viewTpl
) {
  'use strict';

  var PAGE_SIZE = 25;

  /** Text in the user's language, else English, else the first one there is. */
  function translate(name) {
    var values = name && name.get ? name.get('values') : (name && name.values);
    if (!values) {
      return '';
    }
    var lang = (Settings.get('lang') || '').toLowerCase();
    var found = _.find(_.keys(values), function (key) {
      return key.toLowerCase() === lang;
    }) || _.find(_.keys(values), function (key) {
      return key.toLowerCase() === 'en';
    }) || _.keys(values)[0];
    return found ? values[found] : '';
  }

  var PimPrintVariationsView = Marionette.ItemView.extend({
    template: viewTpl,
    className: 'pim-print-variations',

    events: {
      'change .js-step-filter': 'onFilterChange',
      'change .js-code-filter': 'onFilterChange',
      'click .js-page-prev': 'onPagePrev',
      'click .js-page-next': 'onPageNext'
    },

    initialize: function () {
      this.page = 0;
      this.filters = {};
      this.codeFilter = '';
      this.buildRows();
    },

    /** The steps in their order and one row per variation, computed once. */
    buildRows: function () {
      var data = this.options.pimProduct.get('data');
      var optionsByPimId = {};
      var optionsByCode = {};

      this.steps = _.chain(data.get('productOptionCategories').models)
        .sortBy(function (poc) {
          return poc.get('displayOrder') || 0;
        })
        .map(function (poc) {
          var values = _.chain(poc.get('productOptions').models)
            .sortBy(function (po) {
              return po.get('displayOrder') || 0;
            })
            .map(function (po) {
              var value = {pimId: po.get('pimId'), name: translate(po.get('name')) || po.get('code')};
              optionsByPimId[po.get('pimId')] = value;
              optionsByCode[poc.get('code') + '|' + po.get('code')] = value;
              return value;
            })
            .value();
          return {code: poc.get('code'), name: translate(poc.get('name')) || poc.get('code'), values: values};
        })
        .value();

      var stepIndex = {};
      _.each(this.steps, function (step, index) {
        stepIndex[step.code] = index;
      });

      this.rows = _.map(data.get('productCodeVariations').models, function (pcv) {
        var cells = _.map(this.steps, function () {
          return null;
        });
        _.each(pcv.get('productOptions').models, function (po) {
          var value = optionsByPimId[po.get('pimId')] || optionsByCode[po.get('categoryCode') + '|' + po.get('code')];
          var index = stepIndex[po.get('categoryCode')];
          if (value && index !== undefined) {
            cells[index] = value;
          }
        });
        return {
          code: pcv.get('code'),
          cells: cells,
          templateUrl: pcv.get('templateUrl') || null
        };
      }, this);
      this.rows = _.sortBy(this.rows, 'code');
    },

    filteredRows: function () {
      var code = this.codeFilter.toLowerCase();
      return _.filter(this.rows, function (row) {
        if (code && row.code.toLowerCase().indexOf(code) === -1) {
          return false;
        }
        return _.every(this.filters, function (pimId, index) {
          return !pimId || (row.cells[index] && row.cells[index].pimId === pimId);
        });
      }, this);
    },

    onFilterChange: function () {
      var filters = {};
      this.$('.js-step-filter').each(function () {
        filters[this.getAttribute('data-step')] = this.value;
      });
      this.filters = filters;
      this.codeFilter = (this.$('.js-code-filter').val() || '').trim();
      this.page = 0;
      this.render();
    },

    onPagePrev: function () {
      if (this.page > 0) {
        this.page--;
        this.render();
      }
    },

    onPageNext: function () {
      if ((this.page + 1) * PAGE_SIZE < this.filteredRows().length) {
        this.page++;
        this.render();
      }
    },

    serializeData: function () {
      var rows = this.filteredRows();
      var pages = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
      this.page = Math.min(this.page, pages - 1);
      return {
        steps: this.steps,
        filters: this.filters,
        codeFilter: this.codeFilter,
        total: this.rows.length,
        count: rows.length,
        rows: rows.slice(this.page * PAGE_SIZE, (this.page + 1) * PAGE_SIZE),
        page: this.page + 1,
        pages: pages
      };
    }
  });

  module.exports = PimPrintVariationsView;
});

